import React, { Component } from 'react';
import { Route } from 'react-router-dom';
//import { Container } from 'reactstrap';
import Chat from './components/Chat';
import Footer from './components/Footer';
import { observer } from "mobx-react";
// import './App.css';
import './App.css'

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {classBody: 'App'}
    }
    
    
    componentDidMount() {
        let params = window.location.search.split('&');
        const project = params[0].replace('?','');
        switch(project) {
            case 'wup' :
                    this.setState(prevState => ({
                        classBody: 'App wiseupPlusBody'
                    }));
                break;
            case 'wendy':
                    this.setState(prevState => ({
                        classBody: 'App wiseupOnlineBody'
                    }));
                break;
            case 'peter':
                this.setState(prevState => ({
                    classBody: 'App powerHouseBody'
                }));
                break;
            default:
                break;
        }
    }

    render() {
        return (
            <div className={ this.state.classBody }>

                <div className="boxchat">
                
                        <Chat />
                    
                        <Route path='/' component = { Footer } />
                </div>
            </div>
        );
    }
}

export default observer(App);

